import { takeEvery, call, select } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';
import { selectUserInfo } from 'selectors/general';
import { venueSmartspotData } from 'store/saga/entities/bound';

export const DISMISS_SMART_SPOT_BANNER = 'DISMISS_SMART_SPOT_BANNER';

export const dismissSmartSpotBanner = ({ venueId }) => ({
  type: DISMISS_SMART_SPOT_BANNER,
  venueId,
});

export function* doDismissSmartSpotBanner(dependencies, { venueId }) {
  const { userId } = yield select(selectUserInfo);

  yield call(fetchEntity, venueSmartspotData, [
    dependencies,
    {
      meta: {
        userId,
        venueId,
        dismissed: true,
      },
    },
  ]);
}

export function* watchSmartSpotBannerActions(dependencies) {
  yield takeEvery(DISMISS_SMART_SPOT_BANNER, doDismissSmartSpotBanner, dependencies);
}
